import { AssetType, AssetData } from "../../types/models/AssetBase";

/**
 * Gets the asset name for display
 */
export function getAssetName(
  asset: Pick<AssetData, "type" | "name" | "code" | "address" | "tokenId">,
  removeSuffix = true,
) {
  let name =
    asset.name.trim() ||
    asset.code.trim() ||
    asset.address?.trim() ||
    "<unknown>";

  // The asset data which was originally synced from CryptoCompare contains the
  // asset code in brackets in the name, but we don't want to display that.
  // e.g. Bitcoin (BTC) -> Bitcoin.
  if (removeSuffix) {
    name = name.replace(` (${asset.code})`, "");
  }

  // add tokenId
  name =
    asset.type === AssetType.NFT && asset.tokenId ?
      `${name} #${asset.tokenId}`
    : name;

  return name;
}
